/**
 * 分镜→导演台 cast 预排（directormapping 纯逻辑）。
 *
 * 边界：角色名当前**没有专属 3D 形象**（D-33 角色资产来源未定），所以"带入角色"落实为——
 * 按该镜出场角色**名额与命名**生成对应素体（在可用体循环取型），排一排面向镜头；具体长相/站位
 * 留给用户在导演台摆。这是"人数+命名+可摆"的 MVP，不是"形象精确还原"（后者待 D-33 落地）。
 */
import type { BodyType } from '../../model/director';

/** 角色体型（排除 crowd/geometry，与导演台页面同一口径）。 */
export type CharacterBody = Exclude<BodyType, 'crowd' | 'geometry'>;

/** 可用作角色的素体（对齐 assets 里有 GLB 的四种；crowd/geometry 不当角色）。 */
export const CHARACTER_BODIES: CharacterBody[] = ['standard', 'robust', 'broad', 'child'];

export interface CastSeed {
  name: string;
  body: CharacterBody;
}

/**
 * 依据该镜出场角色规划要补的 cast：去重、跳过场景里已同名的对象，体形按顺序循环。
 * characters 为空或全部已存在 → 返回 []（不重复塞人）。纯函数可测。
 */
export function planCastSeed(characters: string[], existingNames: string[]): CastSeed[] {
  const taken = new Set(existingNames);
  const out: CastSeed[] = [];
  let i = 0;
  for (const raw of characters) {
    const name = raw.trim();
    if (name === '' || taken.has(name)) {
      continue;
    }
    taken.add(name);
    const body = CHARACTER_BODIES[i % CHARACTER_BODIES.length] ?? 'standard';
    out.push({ name, body });
    i += 1;
  }
  return out;
}
